<template>
  <div class="min-h-screen w-full bg">
    <RouterView />
  </div>
</template>
<style scoped>
.bg {
  background-color: #f9fafb;
}
</style>
